import React from 'react';
import { FileTextIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
type TrustStripProps = {
  className?: string;
  /** 'short' is the 3-item row under a CTA, 'full' adds the digital format. */
  variant?: 'short' | 'full';
};
const SHORT = [{
  Icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}, {
  Icon: LockIcon,
  label: 'Secure Payment'
}, {
  Icon: ZapIcon,
  label: 'Instant Access'
}];
const FULL = [{
  Icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}, {
  Icon: LockIcon,
  label: 'Secure Payment'
}, {
  Icon: ZapIcon,
  label: 'Instant Digital Access'
}, {
  Icon: FileTextIcon,
  label: '100% Digital'
}];
export function TrustStrip({
  className = '',
  variant = 'short'
}: TrustStripProps) {
  const items = variant === 'full' ? FULL : SHORT;
  return <ul className={`flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-[10px] font-medium uppercase tracking-[0.14em] text-muted sm:text-[11px] ${className}`} data-id="element-321" data-mp="3us97auqr7rf7">
      {items.map(({
      Icon,
      label
    }) => <li key={label} className="flex items-center gap-1.5 whitespace-nowrap" data-id="element-322" data-mp="3msbevmsul7uj">
          <Icon className="h-3 w-3 text-aqua" strokeWidth={1.75} aria-hidden="true" data-id="element-323" data-mp="3rre8mb3dnrn7" />
          {label}
        </li>)}
    </ul>;
}